<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppInputWithValidation
        :value="value"
        :error="dateOfBirthError"
        :mask="inputMask"
        :pattern="/\d*/"
        placeholder="__ / __ / ____"
        name="date_of_birth"
        type="tel"
        placeholder-char="_"
        :hide-error="!submitted"
        label="MM / DD / YYYY"
        :rules="rules"
        data-layer="birth_date_field"
        :theme="theme"
        @input="setDate"
        @reset="handleReset"
        @filled="updateStore"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="handleContinue"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppInputWithValidation from '@/components/common/inputs/AppInputWithValidation'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import input from '@/mixins/input'
import submitLoans from '@/mixins/submit/submit-loans'
import step from '@/mixins/step'

export default {
  // Name
  name: 'DateOfBirth',

  // Components
  components: {
    AppButton,
    AppInputWithValidation,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [
    input,
    submitLoans,
    navigation,
    step
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'What Is Your Date Of Birth?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      inputMask: [/\d/, /\d/, ' ', '/', ' ', /\d/, /\d/, ' ', '/', ' ', /\d/, /\d/, /\d/, /\d/],
      value: undefined,
      dates: [],
      day: '',
      month: '',
      year: '',
      months: [
        'January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December'
      ]
    }
  },

  // Computed
  computed: {

    dateOfBirthError () {
      return this.$store.state.validations.dateOfBirthError
    },

    birthData () {
      return this.$store.getters.birthData
    },

    dataLayerObject () {
      return {
        event: `spring_${this.eventPrefix}_birthdate_continue`
      }
    },

    isPersonalLoan () {
      return this.$store.getters['loans/isPersonalLoan']
    },

    isFoundation () {
      return this.$store.getters['loans/isFoundation']
    },

    rules () {
      const defaultRules = 'required:Date of birth|isValidDate'

      // Use province to determine age of majority
      if (this.isPersonalLoan || this.isFoundation) {
        const province = this.$store.state.location.province
        return `${defaultRules}|isOfAge:${province}`
      }

      return `${defaultRules}|isOfAge`
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    },
    value: function (newValue) {
      // validate the date of birth on change after continue is clicked
      if (this.submitted) {
        this.$_navigation_validateStep()
      }
    }
  },

  // Created
  created () {
    if (this.months.indexOf(this.birthData.dob_month) > -1) {
      let month = this.months.indexOf(this.birthData.dob_month) + 1
      month = month.toString().length === 1 ? `0${month}` : month
      this.value = `${month} / ${this.birthData.dob_day} / ${this.birthData.dob_year}`
    }
  },

  // Mounted
  mounted () {
    if (this.value) this.setDate(this.value)
  },

  methods: {
    setDate (value) {
      this.value = value

      if (value) {
        this.dates = value.replace(/_| /g, '').split('/')
        let day = this.dates[1]
        let monthIndex = parseInt(this.dates[0], 10) - 1
        let year = this.dates[2]
        this.day = day
        this.year = year

        if (+this.dates[0] > 0 && +this.dates[0] <= 12) {
          this.month = this.months[monthIndex]
        } else {
          this.month = undefined
        }
      }
    },

    updateStore () {
      const fieldData = [
        { value: this.day, vuexAction: 'setDobDay' },
        { value: this.month, vuexAction: 'setDobMonth' },
        { value: this.year, vuexAction: 'setDobYear' },
        { value: this.value, vuexAction: 'setBirthDate' }
      ]

      fieldData.forEach(field => {
        this.$store.dispatch(field.vuexAction, field.value)
      })
    },

    handleReset () {
      this.value = undefined
      this.submitted = false
      this.setDate()
    },

    async handleContinue () {
      this.submitted = true
      if (this.submitting) return
      const isValid = await this.$_navigation_validateStep()
      if (!isValid) return

      return this.$_step_handleContinue(this.birthData, this.dataLayerObject)
    }

  }
}
</script>

<style scoped lang="scss">
</style>
